module.exports = __webpack_public_path__ + "img/photo2_6.f479825c.jpg";